import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import SettingsComponent from "../../components/settings/settings-new";
import Settings from "../../components/settings";
import { FEATURE_TOGGLE_SETTINGS } from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import * as settingsActions from "../../store/actions/permissions.js";
import * as companiesActions from "../../store/actions/company/index";
import * as permissionsActions from "../../store/actions/permissions";
import Page from "../../components/general/page";

class SettingsView extends Component {
  static propTypes = {
    accountantSelected: PropTypes.string,
    accountantIdSelected: PropTypes.string,
    accountantUuidSelected: PropTypes.string,
    companyUuidSelected: PropTypes.string,
    auth: PropTypes.object,
    company: PropTypes.object,
    companySelected: PropTypes.string,
    clientIdSelected: PropTypes.string,
    currentPermissions: PropTypes.object,
    dashboard: PropTypes.object,
    documents: PropTypes.object,
    getPermissionsClientsList: PropTypes.func,
    getSettingsCompany: PropTypes.func,
    getUsersList: PropTypes.func,
    pageRef: PropTypes.object,
    savePermissions: PropTypes.func,
    statistics: PropTypes.object,
    user: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      companiesPage: 0,
      companiesSize: 100,
      companiesSearchTerm: "",
    };
  }

  companiesLoad() {
    const { accountantIdSelected, loadCompanyForSettings, companiesLoaded } = this.props;
    const { companiesPage, companiesSize, companiesSearchTerm } = this.state;

    loadCompanyForSettings("", companiesPage, companiesSize, companiesLoaded, accountantIdSelected, companiesSearchTerm);
  }
  componentDidMount() {
    const { getUsersList } = this.props;
    localStorage.setItem("inClassificator", false);

    getUsersList();
    this.companiesLoad();
  }

  render() {
    const {
      auth,
      company,
      companySelected,
      clientIdSelected,
      currentPermissions,
      accountantSelected,
      accountantIdSelected,
      accountantUuidSelected,
      companyUuidSelected,
      getSettingsCompany,
      savePermissions,
      getPermissionsClientsList,
      usersList,
      pageRef,
    } = this.props;
    const CustomComponent = FEATURE_TOGGLE_SETTINGS === "true" ? SettingsComponent : Settings;
    return (
      <Page pageRef={pageRef} noHeaderContent noClassName>
        {currentPermissions.permissionClient ? (
          <CustomComponent
            auth={auth}
            currentPermissions={currentPermissions}
            clientIdSelected={clientIdSelected}
            // SOSTITUIRE COMPANY E CHIAMARE DENTRO OGNI COMPONENTE LA NUOVA ACTION DEI PERMESSI CHE CARICA LE AZIENDE
            // loadCompanyForSettings
            company={company}
            companySelected={companySelected}
            savePermissions={savePermissions}
            accountantSelected={accountantSelected}
            accountantIdSelected={accountantIdSelected}
            accountantUuidSelected={accountantUuidSelected}
            companyUuidSelected={companyUuidSelected}
            getPermissionsClientsList={getPermissionsClientsList}
            getSettingsCompany={getSettingsCompany}
            usersList={usersList}
          />
        ) : (
          <FontAwesomeIcon icon={["far", "circle-notch"]} spin style={{ fontSize: "23px" }} />
        )}
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    accountantSelected: state.main.accountantSelected,
    accountantIdSelected: state.main.accountantIdSelected,
    accountantUuidSelected: state.main.accountantUuidSelected,
    companyUuidSelected: state.main.companyUuidSelected,
    companySelected: state.main.companySelected,
    clientIdSelected: state.main.clientIdSelected,
    company: state.company,
    dashboard: state.dashboard,
    documents: state.documents,
    currentPermissions: state.currentPermissions,
    statistics: state.statistics,
    usersList: state.usersList,
    companiesLoaded: state.currentPermissions.companySettingsList.companies,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    settingsActions: bindActionCreators(settingsActions, dispatch),
    companiesActions: bindActionCreators(companiesActions, dispatch),
    getSettingsCompany: () => {
      dispatch(settingsActions.getSettingsCompany());
    },
    savePermissions: (settings, companyId) => {
      dispatch(settingsActions.savePermissions(settings, companyId));
    },
    getUsersList: () => {
      dispatch(companiesActions.getUsersList());
    },
    loadCompanyForSettings: bindActionCreators(settingsActions.loadCompanyForSettings, dispatch),
    getPermissionsClientsList: bindActionCreators(permissionsActions.getPermissionsClientsList, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsView);
